import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar({ onLogout }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const location = useLocation();

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setIsLoggedIn(true);
      setUsername(storedUsername);
    } else {
      setIsLoggedIn(false);
      setUsername('');
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('userEmail');
    localStorage.removeItem('username');
    localStorage.removeItem('userId');
    setIsLoggedIn(false);
    setUsername('');
    if (typeof onLogout === 'function') onLogout();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">📚</span>
          <span className="logo-text">Bookmarkd</span>
        </Link>
        <div className="navbar-links">
          <Link to="/" className="nav-link">Home</Link>
          {isLoggedIn && (
            <>
              <Link to="/recommended" className="nav-link">Recommended</Link>
              <Link to="/my-books" className="nav-link">My Books</Link>
              <Link to="/profile" className="nav-link">My Profile</Link>
            </>
          )}
        </div>
        <div className="navbar-auth">
          {isLoggedIn ? (
            <div className="user-menu">
              <div className="user-info">
                <span className="user-email">{username}</span>
              </div>
              <button onClick={handleLogout} className="logout-button">Logout</button>
            </div>
          ) : (
            <Link to="/login" className="login-button">Sign In</Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;